module.exports = __webpack_public_path__ + "static/media/spinner-black.f1e4a8da.svg";